import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "light-bulb",
  "use": "light-bulb-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"light-bulb\"><path d=\"m9.1 11.2c-.2.2-.1.5.1.7s.5.1.7-.1l3-4c.2-.3 0-.8-.4-.8h-4l2.4-3.2c.2-.2.1-.5-.1-.7s-.5-.1-.7.1l-3 4c-.2.3 0 .8.4.8h4zm3.4 6.8h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm-1 2h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5zm2.8-8.9c-.5.5-.8 1.1-.8 1.9l-.2 2h-6.6l-.2-2c-.1-.7-.4-1.4-.9-1.9-1.2-1.4-1.8-3.2-1.5-5.1.4-2.6 2.6-4.7 5.2-5 1.7-.2 3.4.4 4.7 1.5s2 2.7 2 4.4c0 1.6-.6 3.1-1.7 4.2m.4-9.3c-1.5-1.3-3.5-2-5.5-1.8-3.1.4-5.7 2.8-6.1 5.9-.3 2.1.3 4.3 1.8 5.9.3.3.5.8.6 1.3l.3 2.5c0 .2.2.4.5.4h7.4c.3 0 .5-.2.5-.4l.3-2.5c.1-.5.3-.9.6-1.3 1.3-1.3 1.9-3 1.9-4.8 0-2-.9-3.9-2.3-5.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/light-bulb.svg
// module id = 759
// module chunks = 0